




















































import Vue from 'vue';
import Component from 'vue-class-component';
import { UsersRepository } from '@/repository/UsersRepository';
import { Authentication } from '@/components/Authentication';
import SignUpConfirmation from '@/components/SignUpConfirmation.vue';

@Component({
  components: {
    SignUpConfirmation,
  },
})
export default class SignIn extends Vue {
  private email: string = '';
  private password: string = '';
  private isConfirmingSignUp: boolean = false;

  private async login() {
    Authentication.signIn(this.email, this.password)
    .then(() => this.$router.go(-1))
    .catch((err) => {
      if (err.code === 'UserNotConfirmedException') {
        // resend code
        Authentication.resendSignUp(this.email);
        this.openConfirmingWindow();
      } else {
        alert('サインインに失敗しました。メールアドレス/パスワードを確認してください。');
      }
    });
  }

  private async onConfirmationFinished() {
    this.closeConfirmingWindow();
    await Authentication.signIn(this.email, this.password);
    UsersRepository.create(this.email);
    this.$router.push('/');
  }

  private onConfirmationCanceled() {
    this.closeConfirmingWindow();
  }

  private openConfirmingWindow() {
    this.isConfirmingSignUp = true;
  }

  private closeConfirmingWindow() {
    this.isConfirmingSignUp = false;
  }
}
